const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');

// Any link to this raw URL will trigger the Donation UI rather than the link target.
const HIJACK_URL_REGEX = /^https?:\/\/bestff.kindful.com(?:\/\?campaign=(\d+))?$/;

const InvokeDonation = forgeUiComponent('InvokeDonation', {}, function InvokeDonationConstructor() {
  const self = this;

  this.element.addEventListener('click', function (e) {
    self.element.dispatchEvent(new CustomEvent(events.uiWantsDonation, { bubbles: true }));
    e.preventDefault();
  });

  // Also invoke for any link that exactly matches HIJACK_URL
  document.body.addEventListener('click', function (e) {
    const linkTarget = e.target && e.target.closest && e.target.closest('A');
    if (linkTarget && HIJACK_URL_REGEX.test(linkTarget.href)) {
      e.preventDefault();
      const campaignId = RegExp.$1;
      const eventDetail = campaignId ? { campaign: campaignId } : {};
      self.element.dispatchEvent(new CustomEvent(events.uiWantsDonation, {
        bubbles: true,
        detail: eventDetail
      }));
    }
  });
});

module.exports = InvokeDonation;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/invokedonation.js
// module id = 57
// module chunks = 0